import { Table } from 'rsuite';
import EmployeeDataviewTooltip from '../../../../components/EmployeeDataviewTooltip';
import './EmployeeSelectionsTable.scss';

const { Cell } = Table;

/**
 * @param {{
 *  dataviewEmployeeData: ManagerAppData.IEmployee[],
 *  rowData: BidProfileManagement.EmployeeSelectionsTableRowData
 * }} input
*/
const NameCell = ({ dataviewEmployeeData, rowData, ...props }) => { // TODO KAT 06/16: What fields needs to be displayed in tooltip?
    const row = dataviewEmployeeData.find((x) => x.employeeId === rowData.employeeId);
    if (!row) { // No dataviews found -> no tooltip
        return (
            <Cell {...props}>
                <span>{rowData.fullName}</span>
            </Cell>
        );
    }

    return (
        <Cell {...props}>
            <EmployeeDataviewTooltip
                employeeName={row.employeeName}
                dataviewAttributes={row.dataviewAttributes}
            />
        </Cell>
    );
};

export default NameCell;
